import { randomNumber } from '../../utilities'
import NumberPadItem from './numberPadItem'

export default class NumberPadItemRow {
  key: string
  items: NumberPadItem[]

  constructor(chars: string[]) {
    this.key = randomNumber().toString()

    this.items = []

    chars.forEach((c) => {
      this.items.push(new NumberPadItem(c))
    })
  }
}
